import { useMemo, useState } from 'react'
import { THREADS_SECTION_PREVIEW_LIMIT } from './threadsSectionConstants.js'

export function useThreadsSectionPreview(filteredThreads) {
  const [viewAllOpen, setViewAllOpen] = useState(false)

  const hasMoreThanPreview = filteredThreads.length > THREADS_SECTION_PREVIEW_LIMIT

  const visibleThreads = useMemo(() => {
    if (!hasMoreThanPreview) return filteredThreads
    return filteredThreads.slice(0, THREADS_SECTION_PREVIEW_LIMIT)
  }, [filteredThreads, hasMoreThanPreview])

  const openViewAll = () => setViewAllOpen(true)
  const closeViewAll = () => setViewAllOpen(false)

  return {
    visibleThreads,
    viewAllOpen,
    hasMoreThanPreview,
    openViewAll,
    closeViewAll,
  }
}
